import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const keyOf = (i) => `${i.product_id}|${i.size}|${i.color}`;
const load = (k) => {
  try {
    return JSON.parse(localStorage.getItem(k)) || [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => load("qamar_cart"));
  const [wishlist, setWishlist] = useState(() => load("qamar_wishlist"));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("qamar_cart", JSON.stringify(items));
  }, [items]);
  useEffect(() => {
    localStorage.setItem("qamar_wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const add = (item) =>
    setItems((prev) => {
      const k = keyOf(item);
      const found = prev.find((p) => keyOf(p) === k);
      if (found) return prev.map((p) => (keyOf(p) === k ? { ...p, qty: Math.min(p.qty + item.qty, item.max || 20) } : p));
      return [...prev, item];
    });
  const setQty = (k, qty) => setItems((prev) => prev.map((p) => (keyOf(p) === k ? { ...p, qty: Math.max(1, qty) } : p)));
  const remove = (k) => setItems((prev) => prev.filter((p) => keyOf(p) !== k));
  const clear = () => setItems([]);
  const toggleWish = (id) => {
    const has = wishlist.includes(id);
    setWishlist((w) => (has ? w.filter((x) => x !== id) : [...w, id]));
    return !has;
  };

  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, open, setOpen, keyOf, wishlist, toggleWish }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
